module.exports = __webpack_public_path__ + "img/juanHand.93e8e50b.png";